module.exports = __webpack_public_path__ + "canny-microsoft-teams-integration-6f7c4b27b1214945ee23538f71542e5b.webp";